export enum AuthorityBill {
  FINANCIAL_BILL_READ_RETURN_FILE = '3.8.3',
  FINANCIAL_BILL_GENERATE_REMITTANCE_FILE = '3.8.2',
  FINANCIAL_BILL_VIEW_TICKET_HISTORY = '3.8.1',
  FINANCIAL_BILL_TICKET_BANK_SLIP = '3.8',
}
